let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lNJCe")).then(() => parcelRequire('dpLfC'));